// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"373":"4df41002","830":"fea0b9ab"}[chunkId] + ".chunk.css";
};